module.exports = __webpack_public_path__ + "img/pethouse40.2366e682.jpg";